module.exports = globalThis["crateImports"]["@apollo/client"];